// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

.careers-container {
  min-height: 100vh;
  background: #f8f9fa;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Hero Section */
.hero-section {
  position: relative;
  width: 100%;
  min-height: 400px; 
  height: 81vh; 
  overflow: hidden;
  border-radius: 0;
  margin-bottom: 60px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  color: white;
  font-family: "Montserrat", sans-serif;
}

.hero-title {
  font-size: clamp(2rem, 5vw, 3rem); 
  font-weight: 700;
  margin-bottom: 20px;
  text-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  font-size: clamp(1rem, 2.5vw, 1.2rem); 
  margin-bottom: 30px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.search-bar {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap; 
}

.search-bar input {
  padding: 10px 20px;
  border: none;
  border-radius: 50px;
  width: 100%;
  max-width: 400px;
  font-size: 1rem;
  outline: none;
}

.search-button {
  padding: 10px 20px;
  background: #764ba2;
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.search-button:hover {
  background: #667eea;
}

/* Job Listings Section */
.careers-content {
  max-width: 1200px;
  width: 100%;
  text-align: center;
  padding: 20px;
}

.jobs-title {
  font-size: clamp(1.5rem, 4vw, 2rem); 
  color: #333;
  font-weight: bold;
  margin-bottom: 10px;
}

.jobs-subtitle {
  font-size: clamp(0.9rem, 2.5vw, 1rem); 
  color: #777;
  margin-bottom: 60px;
}

.job-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.job-card {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  padding: 20px;
  text-decoration: none;
  color: inherit;
}

.job-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.job-title {
  font-size: clamp(1rem, 2.5vw, 1.2rem); 
  color: #333;
  font-weight: 600;
  margin-bottom: 10px;
}
.job-card-content h1 {
  font-size: 1.5rem;
  font-family: "Montserrat", sans-serif;
}

.job-category {
  font-size: clamp(0.9rem, 2.5vw, 1rem); 
  color: #667eea;
  font-weight: 500;
  margin-bottom: 15px;
}

.job-location,
.job-posted {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: clamp(0.8rem, 2.5vw, 0.9rem); 
  color: #555;
  margin-bottom: 10px;
}

.location-icon,
.clock-icon {
  font-size: 1rem;
  color: #667eea;
}

.job-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #667eea;
  font-weight: 600;
  transition: color 0.3s ease;
}

.job-link:hover {
  color: #764ba2;
}

.link-icon {
  transition: transform 0.3s ease;
}

.job-link:hover .link-icon {
  transform: translateX(5px);
}

/* Footer Section */
.footer {
  background: linear-gradient(135deg, #1a1a1a, #2c3e50);
  color: white;
  padding: 60px 20px 20px;
  width: 100%;
  margin-top: 60px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-section {
  text-align: left;
}

.footer-section h3 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  font-weight: 600;
}

.footer-section p {
  font-size: 1rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 10px;
}

.footer-section ul li a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-section ul li a:hover {
  color: #ffeb3b;
}

.social-icons {
  display: flex;
  gap: 15px;
}

.social-icons a {
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.3s ease;
}

.social-icons a:hover {
  color: #ffeb3b;
}

.newsletter-form {
  display: flex;
  gap: 10px;
}

.newsletter-form input {
  padding: 10px;
  border: none;
  border-radius: 5px;
  flex: 1 1;
}

.newsletter-form button {
  padding: 10px 20px;
  background: #ff6b6b;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.newsletter-form button:hover {
  background: #764ba2;
}

.footer-bottom {
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
}

/* Media Queries for Responsiveness */
@media (max-width: 768px) {
  .hero-section {
    height: 50vh; 
  }

  .search-bar {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .search-bar input {
    width: 100%;
    max-width: 300px;
  }

  .search-button {
    width: 100%;
    max-width: 300px;
  }

  .job-cards {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .footer-section {
    text-align: center;
  }
}

@media (max-width: 480px) {
  .hero-section {
    height: 40vh;
  }

  .job-cards {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
}

@media (max-width: 768px) {
  .search-bar {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Careers.css"],"names":[],"mappings":";AAGA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,qDAAqD;EACrD,aAAa;EACb,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uCAAuC;EACvC,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,qDAAqD;EACrD,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.careers-container {\n  min-height: 100vh;\n  background: #f8f9fa;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Hero Section */\n.hero-section {\n  position: relative;\n  width: 100%;\n  min-height: 400px; \n  height: 81vh; \n  overflow: hidden;\n  border-radius: 0;\n  margin-bottom: 60px;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 20px;\n}\n\n.hero-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.hero-content {\n  position: relative;\n  z-index: 1;\n  max-width: 800px;\n  color: white;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.hero-title {\n  font-size: clamp(2rem, 5vw, 3rem); \n  font-weight: 700;\n  margin-bottom: 20px;\n  text-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n}\n\n.hero-subtitle {\n  font-size: clamp(1rem, 2.5vw, 1.2rem); \n  margin-bottom: 30px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.search-bar {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  flex-wrap: wrap; \n}\n\n.search-bar input {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 50px;\n  width: 100%;\n  max-width: 400px;\n  font-size: 1rem;\n  outline: none;\n}\n\n.search-button {\n  padding: 10px 20px;\n  background: #764ba2;\n  color: white;\n  border: none;\n  border-radius: 50px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.search-button:hover {\n  background: #667eea;\n}\n\n/* Job Listings Section */\n.careers-content {\n  max-width: 1200px;\n  width: 100%;\n  text-align: center;\n  padding: 20px;\n}\n\n.jobs-title {\n  font-size: clamp(1.5rem, 4vw, 2rem); \n  color: #333;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.jobs-subtitle {\n  font-size: clamp(0.9rem, 2.5vw, 1rem); \n  color: #777;\n  margin-bottom: 60px;\n}\n\n.job-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.job-card {\n  background: white;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  padding: 20px;\n  text-decoration: none;\n  color: inherit;\n}\n\n.job-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n}\n\n.job-title {\n  font-size: clamp(1rem, 2.5vw, 1.2rem); \n  color: #333;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n.job-card-content h1 {\n  font-size: 1.5rem;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.job-category {\n  font-size: clamp(0.9rem, 2.5vw, 1rem); \n  color: #667eea;\n  font-weight: 500;\n  margin-bottom: 15px;\n}\n\n.job-location,\n.job-posted {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: clamp(0.8rem, 2.5vw, 0.9rem); \n  color: #555;\n  margin-bottom: 10px;\n}\n\n.location-icon,\n.clock-icon {\n  font-size: 1rem;\n  color: #667eea;\n}\n\n.job-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n  color: #667eea;\n  font-weight: 600;\n  transition: color 0.3s ease;\n}\n\n.job-link:hover {\n  color: #764ba2;\n}\n\n.link-icon {\n  transition: transform 0.3s ease;\n}\n\n.job-link:hover .link-icon {\n  transform: translateX(5px);\n}\n\n/* Footer Section */\n.footer {\n  background: linear-gradient(135deg, #1a1a1a, #2c3e50);\n  color: white;\n  padding: 60px 20px 20px;\n  width: 100%;\n  margin-top: 60px;\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 30px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.footer-section {\n  text-align: left;\n}\n\n.footer-section h3 {\n  font-size: 1.5rem;\n  margin-bottom: 15px;\n  font-weight: 600;\n}\n\n.footer-section p {\n  font-size: 1rem;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.footer-section ul {\n  list-style: none;\n  padding: 0;\n}\n\n.footer-section ul li {\n  margin-bottom: 10px;\n}\n\n.footer-section ul li a {\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer-section ul li a:hover {\n  color: #ffeb3b;\n}\n\n.social-icons {\n  display: flex;\n  gap: 15px;\n}\n\n.social-icons a {\n  color: rgba(255, 255, 255, 0.8);\n  transition: color 0.3s ease;\n}\n\n.social-icons a:hover {\n  color: #ffeb3b;\n}\n\n.newsletter-form {\n  display: flex;\n  gap: 10px;\n}\n\n.newsletter-form input {\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  flex: 1;\n}\n\n.newsletter-form button {\n  padding: 10px 20px;\n  background: #ff6b6b;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.newsletter-form button:hover {\n  background: #764ba2;\n}\n\n.footer-bottom {\n  text-align: center;\n  margin-top: 40px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* Media Queries for Responsiveness */\n@media (max-width: 768px) {\n  .hero-section {\n    height: 50vh; \n  }\n\n  .search-bar {\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n  }\n\n  .search-bar input {\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .search-button {\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .job-cards {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  }\n\n  .footer-content {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n\n  .footer-section {\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-section {\n    height: 40vh;\n  }\n\n  .job-cards {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .search-bar {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
